import React, {FunctionComponent, useEffect, useState} from "react";

const WasThisHelpful: FunctionComponent<any> = (props) => {
    const [showWTH, setWTH] = useState(true);
    const [isModalOpen, setModal] = useState(false);
    const [message, setMessage] = useState('');

    useEffect(() => {
        const body = document.body;
        isModalOpen ? body.classList.add("modal-open") : body.classList.remove("modal-open");
    });

    const handleMessageChange = (event: any) => {
        setMessage(event.target.value);
        console.log(event.target.value);
    };

    return (
        <React.Fragment>
            {showWTH ?
                <div className="wth-container">
                    <p className="wth-text">Was this video helpful?</p>
                    <button className="wth-yes-btn" onClick={() =>{likeClick(props.videoTitle)}}> Yes</button>
                    <button className="wth-no-btn" data-toggle="modal" data-target={"#feedback-modal-"+props.videoId} onClick={() => { handleShowModal(props.videoId); }}> No</button>

                    <div
                        className="modal feedback-modal"
                        role="dialog"
                        id={"feedback-modal-" + props.videoId}
                        aria-modal="true"
                    >
                        <div className="modal-dialog modal-dialog-scrollable" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4>We're sorry this video was not helpful.<br/>
                                        Could you please tell us why?</h4>
                                    <button
                                        type="button"
                                        className="close-btn modal-close"
                                        data-dismiss="modal"
                                        aria-label="Close"
                                    >
                                    </button>
                                </div>
                                <div className="modal-body">
                                <textarea
                                    rows={5}
                                    value={message}
                                    onChange={handleMessageChange}
                                    className="feedback-content"
                                    placeholder="Enter your feedback here"></textarea>
                                </div>
                                <div className="modal-footer">
                                    <button
                                        id={"submit-feedback-" + props.videoId}
                                        type="button"
                                        className="btn btn-primary btn-common contained-btn cta-active cls-terms-modal submit-feedback"
                                        data-dismiss="modal"
                                        data-toggle="modal" data-target={"#feedback-modal-submitted-"+props.videoId}
                                        onClick={() => { submitFeedback(props.videoId, props.videoTitle); }}
                                    >
                                        Submit Feedback
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        className="modal feedback-modal-submitted"
                        role="dialog"
                        id={"feedback-modal-submitted-"+props.videoId}
                        aria-modal="true"
                    >
                        <div className="modal-dialog modal-dialog-scrollable" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4>We're sorry this video was not helpful.<br/>
                                        Could you please tell us why?</h4>
                                    <button
                                        type="button"
                                        className="close-btn modal-close"
                                        data-dismiss="modal"
                                        aria-label="Close"
                                        onClick={(e) => { handleCloseModal(e, props.videoId); }}
                                    >
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="feedback-content-submitted">
                                        <p>Thank you for taking the time to submit your feedback. We appreciate your help and look into each report we receive.</p>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-danger btn-common contained-btn cta-active cls-terms-modal close-btn"
                                        data-dismiss="modal"
                                        onClick={(e) => { handleCloseModal(e, props.videoId); }}
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> :

                <div className="wth-container">
                    <p className="wth-text">Thanks for your feedback!</p>
                </div>
            }
        </React.Fragment>

    );

    function likeClick(videoTitle: string) {
        console.log("click liked", videoTitle);
        const wthData = {
            'event': 'e_supportVideo_helpful',
            'videoTitle': videoTitle,
            'videoHelpful': 'YES'
        };
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(wthData);
        setWTH(false);
    }

    function handleShowModal(id: string) {
        const modal = document.getElementById("feedback-modal-" + id);
        modal?.setAttribute("style", "display:block");
        const contentElement = modal?.querySelectorAll(".modal-content")[0];
        if (contentElement?.classList.contains("popover")) {
            contentElement.classList.remove("popover");
        }
        if (contentElement?.classList.contains("d-none")) {
            contentElement.classList.remove("d-none");
        }
        setModal(true);
    }

    function handleCloseModal(event: any, id: string) {
        event.stopPropagation();
        const baseElement = event.target;
        // Elements with class name that wont close when clicked
        const classNames = ['modal-body', 'modal-title', 'modal-header'];
        if (classNames.some(function (className) { return baseElement.classList.contains(className); })) {
            return;
        }
        const element = document.getElementById("feedback-modal-submitted-" + id);
        element?.removeAttribute("style");
        setModal(false);
        setWTH(false);
    }

    function submitFeedback(id: string, videoTitle: string) {
        console.log("submitFeedback", id);
        const submitBtn = document.getElementById("submit-feedback-"+id);
        console.log("feedbackContent", message);
        const wthData = {
            'event': 'e_supportVideo_helpful',
            'videoTitle': videoTitle,
            'videoHelpful': 'NO',
            'feedbackReason': message
        };
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(wthData);
        setMessage('');
    }
};

export default WasThisHelpful;